import layout from '@/layout'

/**
 * 新增独立的“行业”一级菜单，不放进融资融券的子路由。
 * 顶层 name 需要保持独立：普通管理员的菜单权限按顶层路由 name 过滤。
 */
export default {
  path: '/industry',
  component: layout,
  redirect: '/industry/sw3',
  name: 'industry',
  meta: {
    title: 'industry',
    // 复用现有行业总览图标，保持一级菜单样式一致。
    icon: 'total'
  },
  children: [
    {
      path: '/industry/sw3',
      name: 'industrySw3',
      // 独立页面使用总览的数据接口，但布局和组件组常设互不影响。
      component: () => import('@/views/industry/sw3/index.vue'),
      meta: {
        title: 'industrySw3',
        icon: 'total'
      }
    }
  ]
}
